module.exports = __webpack_public_path__ + "img/84ne.c22b1bb4.svg";